import m from './module';
import { createError } from '../error';

const getPartialResponsesUrl = '/partial_responses/{{staffing_users_id}}';
const getPartialRecapResponseSetUrl = '/partial_recap_response_set/{{staffing_users_id}}/{{events_id}}';

class PartialResponseService {
  constructor($log,
              $q,
              APIService,
              DataSyncService,
              LogService,
              DateTimeService,
              DocumentService) {
    "ngInject";
    this.$log            = $log;
    this.$q              = $q;
    this.APIService      = APIService;
    this.DataSyncService = DataSyncService;
    this.LogService      = LogService;
    this.DateTimeService = DateTimeService;
  }

  create(data, config = null) {
    const promises = [];
    data = data || {};

    return this.$q
      .all(promises)
      .then(() => {
        return data;
      })
      .catch(err => {
        this.LogService.error("Error creating partial response:", err);
        return this.$q.reject(err);
      });
  }

  getForPosition(position, config = null) {
    let event = position.event;
    let staffUserId = position.staffing_users_id;
    if (!event) {
      return this.$q.reject(createError({
        error: 'MissingEventForPosition',
        message: 'Position does not have an event',
      }));
    }
    if (!staffUserId) {
      return this.$q.reject(createError({
        error: 'NoStaffingUserSpecifiedForPosition',
        message: 'Position is not assigned to a staffing user',
      }));
    }

    let myConfig = {...config};
    if (position.is_guerrilla) {
      myConfig.force = true;
    }
    return this.getAllForStaffingUser({'id':staffUserId}, myConfig)
      .then(responses => {
        let found = responses.find(response => parseInt(response.events_id) === parseInt(event.id));
        if (found) {
          found.position = position;
        }
        return found;
      });
  }

  getPartialResponses(position) {
    let event = position.event;
    let staffUserId = position.staffing_users_id;
    if (!event) {
      return this.$q.reject(createError({
        error: 'MissingEventForPosition',
        message: 'Position does not have an event',
      }));
    }
    if (!staffUserId) {
      return this.$q.reject(createError({
        error: 'NoStaffingUserSpecifiedForPosition',
        message: 'Position is not assigned to a staffing user',
      }));
    }

    return this.getForPosition(position);
  }

  getAllForStaffUserId(staffUserId, config = null) {
    return this.getAllForStaffingUser({'id':staffUserId}, config);
  }

  getAllForStaffingUser(staffingUser, config = null) {
    const staffUserId = staffingUser.id;

    const path = getPartialResponsesUrl.replace('{{staffing_users_id}}', staffUserId);
    return this.DataSyncService.getMultipleObjects('PartialResponses', path, data => this.create(data, config), config)
      .catch(response => {
        this.LogService.error("Error retrieving partial responses (PartialResponseService.getAllForStaffingUser):", response);
        return this.$q.reject(createError({
          error: 'ErrorRetrievingPartialResponses',
          message: 'Error retrieving partial responses from server',
          response,
        }));
      });
  }
}

export default PartialResponseService;

m.service('PartialResponseService', PartialResponseService);
